import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  AfterViewInit,
  AfterViewChecked,
} from "@angular/core";
import { Router } from "@angular/router";
import { ConfigService } from "src/app/config/config.service";
import { AuthService } from "src/app/core/service/auth.service";
import { RightSidebarService } from "src/app/core/service/rightsidebar.service";
import { LanguageService } from "src/app/core/service/language.service";
import { UnsubscribeOnDestroyAdapter } from "src/app/shared/UnsubscribeOnDestroyAdapter";
import { MasterserviceService } from "src/app/coremodule/service/masterservice.service";
import { ConfigServiceService } from "src/app/coremodule/configuration/service/config-service.service";
import { catchError, forkJoin, of, switchMap } from "rxjs";
import { ShareDataService } from "src/app/global_data/share-data.service";
import { AuthTabSyncService } from "src/app/core/service/auth-tab-sync.service";

const document: any = window.document;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit, AfterViewInit
{
  legalEntityId = localStorage.getItem("legalEntityId");
  viewlegal: any[] = [];
  roleData: any;
  legalEntityName: any;
  showLegalEntityOnly: boolean = false;
  roleId: any;
  headerMenuList: any = [];
  time = new Date();
  title: any;
  intervalId;
  public config: any = {};
  userImg: string;
  homePage: string;
  isNavbarCollapsed = true;
  flagvalue;
  countryName;
  langStoreValue: string;
  defaultFlag: string;
  isOpenSidebar: boolean;
  empdetails: any;
  detpdata: any;
  isNavBarHideShow: boolean = false;
  departmentId: any;
  legalEntity: any = 0;
  ViewBusinessArea: any;
  ViewBusinessVertical: any;
  businessArea: any = 0;
  businessVertical: any = 0;
  viewRole: any;
  asignRoleName: any;
  BusinessUnit1: any;
  nav_dropdown_check: any = {
    legalEntityId: "0",
    locationId: "0",
    businessSegmentsId: "0",
    businessAreaId: "0",
  };
  BusinessUnit: any = [];
  newStoreData: any;
  path: any = [];
  roleCode: any;
  userName: any;
  legalEntityAdminRoleId: any;
  clientAdminRoleId: any;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private rightSidebarService: RightSidebarService,
    private configService: ConfigService,
    private authService: AuthService,
    private router: Router,
    public languageService: LanguageService,
    public masterservice: MasterserviceService,
    private configservice: ConfigServiceService,
    private storeData: ShareDataService,
    private tabSyncService: AuthTabSyncService
  ) {
    super();
    this.authService.headerMenuListSubject.subscribe((res) => {
      this.headerMenuList = this.authService.headerMenu;
    });
    this.authService.hideNavBar.subscribe((res) => {
      console.log("hideNavBar>>>>>", res);
      this.isNavBarHideShow = res;
    });
    this.legalEntity = "2";
  }
  listLang = [
    { text: "English", flag: "assets/images/flags/us.svg", lang: "en" },
    { text: "Spanish", flag: "assets/images/flags/spain.svg", lang: "es" },
    { text: "German", flag: "assets/images/flags/germany.svg", lang: "de" },
  ];
  notifications: any[] = [
    {
      message: "Please check your mail",
      time: "14 mins ago",
      icon: "mail",
      color: "nfc-green",
      status: "msg-unread",
    },
    {
      message: "New Patient Added..",
      time: "22 mins ago",
      icon: "person_add",
      color: "nfc-blue",
      status: "msg-read",
    },
    {
      message: "Your leave is approved!! ",
      time: "3 hours ago",
      icon: "event_available",
      color: "nfc-orange",
      status: "msg-read",
    },
    {
      message: "Lets break for lunch...",
      time: "5 hours ago",
      icon: "lunch_dining",
      color: "nfc-blue",
      status: "msg-read",
    },
    {
      message: "Patient report generated",
      time: "14 mins ago",
      icon: "description",
      color: "nfc-green",
      status: "msg-read",
    },
    {
      message: "Please check your mail",
      time: "22 mins ago",
      icon: "mail",
      color: "nfc-red",
      status: "msg-read",
    },
    {
      message: "Salary credited...",
      time: "3 hours ago",
      icon: "paid",
      color: "nfc-purple",
      status: "msg-read",
    },
  ];
  fullname: any = localStorage.getItem("userFullName");
  businessarea: any;
  userId: any;
  bsarea: any;
  setPermission(permission: any, menuLinkId: any) {
    localStorage.setItem("permission", permission);
    localStorage.setItem("menuLinkId", menuLinkId);
  }

  checkActivelink(menu) {
    if (
      menu.menuLinkId === parseInt(localStorage.getItem("menuLinkId")) ||
      this.router.url === menu.functionURL
    ) {
      localStorage.setItem("menuLinkId", menu.menuLinkId);
      return "primary-color";
    }
    return "";
  }

  ngOnInit() {
    console.log(localStorage.getItem("clientAdminRoleId"));
    console.log(localStorage.getItem("legalEntityAdminRoleId"));
    this.legalEntityAdminRoleId = localStorage.getItem(
      "legalEntityAdminRoleId",
    );
    // this.clientAdminRoleId = parseInt(localStorage.getItem('clientAdminRoleId'))
    // this.clientAdminRoleId = parseInt(localStorage.getItem('clientAdminRoleId') || '0', 10);
    this.clientAdminRoleId = localStorage.getItem("clientAdminRoleId") || null;

    console.log("clientAdminRoleId:", this.clientAdminRoleId);

    this.roleId = localStorage.getItem("roleId");
    this.roleCode = localStorage.getItem("roleCode ");
    this.userName = localStorage.getItem("userName");
    this.fetchRoleData();
    this.storeData.currentShareData.subscribe((data: any) => {
      console.log("storedata", data);
      this.loadDependencies();
    });

    this.intervalId = setInterval(() => {
      this.time = new Date();
    }, 1000);

    this.authService
      .EmproleAccess({
        btn_name: "VIEW_ROLE_BYUSER",
        userId: localStorage.getItem("userId"),
        roleId: localStorage.getItem("roleId"),
      })
      .subscribe((res) => {
        this.viewRole = res;
        //
        console.log(this.viewRole);
        localStorage.setItem("roleId", res.roleId);
        this.fetchRoleData();
        this.authService.setRole(this.roleId);
        if (parseInt(localStorage.getItem("roleId"))) {
          this.asignRoleName = parseInt(localStorage.getItem("roleId"));
        } else {
          this.asignRoleName = res ? parseInt(res.roleId) : null;
        }
        // const foundRole = res?.find(
        //   (role) => role.roleId == this.asignRoleName
        // );
        // localStorage.setItem("roleName", foundRole ? foundRole.roleName : null);
        // console.log(this.asignRoleName);
        // if (res) {
        //   localStorage.setItem("roleCode", res.roleCode);
        // }
        const foundRole = res.find(
          (role: any) => role.roleId === this.asignRoleName,
        );

        if (foundRole) {
          localStorage.setItem("roleName", foundRole.roleName);
          localStorage.setItem("roleCode", foundRole.roleCode);
        }
        this.getLegalEntity();
      });
    this.businessarea = parseInt(localStorage.getItem("businessAreaId"));
    this.authService
      .LoginAccessArea(localStorage.getItem("userId"))
      .subscribe((barea) => {
        this.bsarea = barea;
      });
    this.departmentId = parseInt(localStorage.getItem("departmentId"));
    this.masterservice
      .DeptEmpAccess({
        btn_name: "VIEW",
        userId: localStorage.getItem("userId"),
      })
      .subscribe((res) => {
        this.detpdata = res;
      });

    this.config = this.configService.configData;
    const userRole = this.authService.currentUserValue.role;
    this.userImg = this.authService.currentUserValue.img;

    if (userRole === "Admin") {
      this.homePage = "admin/dashboard/main";
    } else if (userRole === "Patient") {
      this.homePage = "patient/dashboard";
    } else if (userRole === "Doctor") {
      this.homePage = "doctor/dashboard";
    } else {
      this.homePage = "admin/dashboard/main";
    }

    this.langStoreValue = localStorage.getItem("lang");
    const val = this.listLang.filter((x) => x.lang === this.langStoreValue);
    this.countryName = val.map((element) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.defaultFlag = "assets/images/flags/us.svg";
      }
    } else {
      this.flagvalue = val.map((element) => element.flag);
    }

    console.log("------------------------------- 1", this.nav_dropdown_check);
    console.log(
      "*********************************************************************************",
    );
  }

  ngAfterViewInit() {
    // set theme on startup
    if (localStorage.getItem("theme")) {
      this.renderer.removeClass(this.document.body, this.config.layout.variant);
      this.renderer.addClass(this.document.body, localStorage.getItem("theme"));
    } else {
      this.renderer.addClass(this.document.body, this.config.layout.variant);
    }

    if (localStorage.getItem("menuOption")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("menuOption"),
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "menu_" + this.config.layout.sidebar.backgroundColor,
      );
    }

    if (localStorage.getItem("choose_logoheader")) {
      this.renderer.addClass(
        this.document.body,
        localStorage.getItem("choose_logoheader"),
      );
    } else {
      this.renderer.addClass(
        this.document.body,
        "logo-" + this.config.layout.logo_bg_color,
      );
    }

    if (localStorage.getItem("sidebar_status")) {
      if (localStorage.getItem("sidebar_status") === "close") {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      } else {
        this.renderer.removeClass(this.document.body, "side-closed");
        this.renderer.removeClass(this.document.body, "submenu-closed");
      }
    } else {
      if (this.config.layout.sidebar.collapsed === true) {
        this.renderer.addClass(this.document.body, "side-closed");
        this.renderer.addClass(this.document.body, "submenu-closed");
      }
    }
    // this.callFullscreen();
    console.log(
      "###########################################################################################################",
    );
  }

  findValue(
    data: Array<any>,
    key: string,
    keyValue: any,
    returnKey: string,
  ): any {
    // console.log(data)
    if (data) {
      const foundObject = data.find((item) => item[key] === keyValue);
      return foundObject ? foundObject[returnKey] : null;
    }
  }

  getLegalEntity() {
    this.configservice
      .getlegalentity({
        userId: localStorage.getItem("userId"),
        roleId: localStorage.getItem("roleId"),
      })
      .subscribe((res) => {
        this.viewlegal = res;
        console.log(res);
        this.loadDependencies();
        this.legalEntity = parseInt(localStorage.getItem("legalEntityId"));

        // console.log(this.legalEntity)
      });
  }

  selectLeBaBvBu(key) {
    if (this.roleId) {
      return key === "legalEntityId";
    }

    switch (key) {
      case "legalEntityId":
        // if (parseInt(localStorage.getItem("legalEntityAdminRoleId")) !== 24) {
        if (localStorage.getItem("legalEntityAdminRoleId") === "24") {
          return true;
        } else {
          return false;
        }
        break;
      case "locationId":
        if (parseInt(localStorage.getItem("label")) === 3) {
          return false;
        } else {
          return true;
        }
        break;
      case "businessSegmentsId":
        if (parseInt(localStorage.getItem("label")) === 3) {
          return false;
        } else {
          return true;
        }
        break;
      case "businessAreaId":
        if (parseInt(localStorage.getItem("label")) === 3) {
          return false;
        } else {
          return true;
        }
        break;
      default:
        return true;
        break;
    }
  }
  loadDependencies() {
    this.legalEntity = parseInt(localStorage.getItem("legalEntityId"));
    // localStorage.setItem(
    //   "legalEntityName",
    //   this.findValue(this.viewlegal, "legalEntityId", this.legalEntity, "title")
    // );
    this.businessArea = parseInt(localStorage.getItem("locationId"));
    this.businessVertical = parseInt(
      localStorage.getItem("businessSegmentsId"),
    );
    this.BusinessUnit1 = parseInt(localStorage.getItem("businessAreaId"));

    // Start loading dependencies
    this.loadBusinessArea();
  }

  loadBusinessArea() {
    if (this.legalEntity) {
      this.configservice
        .getalldependency({
          btn_name: "GETACTUALBUSINESSAREA",
          legalEntityId: this.legalEntity,
          userId: localStorage.getItem("userId"),
          roleID: localStorage.getItem("roleId"),
        })
        .pipe(
          catchError((error) => {
            console.error("Error fetching business area:", error);
            return of(null); // Return an observable with a null value in case of error
          }),
        )
        .subscribe((res) => {
          // localStorage.setItem("actuallBusinessAreaId", res[0].actuallBusinessAreaId)
          this.ViewBusinessArea = res;
          this.selectDropdowns();
          this.loadBusinessVertical();
        });
    }
  }

  loadBusinessVertical() {
    if (this.businessArea) {
      this.configservice
        .getalldependency({
          btn_name: "GETACTUALBUSINESSVERTICAL_BYAREA",
          legalEntityId: this.legalEntity,
          locationId: localStorage.getItem("locationId"),

          userId: localStorage.getItem("userId"),
          roleID: localStorage.getItem("roleId"),
        })
        .pipe(
          catchError((error) => {
            console.error("Error fetching business vertical:", error);
            return of(null); // Return an observable with a null value in case of error
          }),
        )
        .subscribe((res) => {
          this.ViewBusinessVertical = res;
          this.selectDropdowns();
          this.loadBusinessUnit();
        });
    }
  }

  loadBusinessUnit() {
    if (this.businessVertical) {
      this.configservice
        .getalldependency({
          btn_name: "GETACTUALBUSINESSUNIT",
          legalEntityId: this.legalEntity,
          locationId: localStorage.getItem("locationId"),

          businessSegmentsId: this.businessVertical,
          userId: localStorage.getItem("userId"),
          roleID: localStorage.getItem("roleId"),
          businessAreaId: localStorage.getItem("businessAreaId"),
        })
        .pipe(
          catchError((error) => {
            console.error("Error fetching business unit:", error);
            return of(null); // Return an observable with a null value in case of error
          }),
        )
        .subscribe((res) => {
          this.BusinessUnit = res;
          this.selectDropdowns();
        });
    }
  }

  selectDropdowns() {
    this.legalEntity = parseInt(localStorage.getItem("legalEntityId"));
    this.businessArea = parseInt(localStorage.getItem("locationId"));
    this.businessVertical = parseInt(
      localStorage.getItem("businessSegmentsId"),
    );
    this.BusinessUnit1 = parseInt(localStorage.getItem("businessAreaId"));
    // localStorage.setItem("legalEntityName",this.findValue( this.viewlegal,"legalEntityId",this.legalEntity,"legalEntityName"));
    localStorage.setItem(
      "locationName",
      this.findValue(
        this.ViewBusinessArea,
        "locationId",
        this.businessArea,
        "businessareaName",
      ),
    );
    localStorage.setItem(
      "legalEntityTitle",
      this.findValue(
        this.viewlegal,
        "legalEntityId",
        this.legalEntity,
        "title",
      ),
    );
    localStorage.setItem(
      "locationTitle",
      this.findValue(
        this.ViewBusinessArea,
        "locationId",
        this.businessArea,
        "aliasName",
      ),
    );
    localStorage.setItem(
      "businessSegmentsName",
      this.findValue(
        this.ViewBusinessVertical,
        "businessSegmentsId",
        this.businessVertical,
        "businessVertical",
      ),
    );
    localStorage.setItem(
      "businessAreaName",
      this.findValue(
        this.BusinessUnit,
        "businessAreaId",
        this.BusinessUnit1,
        "businessUnitName",
      ),
    );
  }
  setbarea(id: any) {
    this.nav_dropdown_check.businessAreaId = id;
    localStorage.setItem("businessAreaId", id);
    this.authService.setRole(this.roleId);

    this.authService.notifyDropdownChange();
    this.selectDropdowns();
    // this.router.navigate(["/admin/dashboard/main"]);
  }

  setdept(id: any) {
    localStorage.setItem("departmentId", id);
    this.router.navigate(["/coremodule/Dashboard"]);
    this.selectDropdowns();
  }

  callFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.langStoreValue = lang;
    this.languageService.setLanguage(lang);
  }
  mobileMenuSidebarOpen(event: any, className: string) {
    const hasClass = event.target.classList.contains(className);
    if (hasClass) {
      this.renderer.removeClass(this.document.body, className);
    } else {
      this.renderer.addClass(this.document.body, className);
    }
  }
  callSidemenuCollapse() {
    const hasClass = this.document.body.classList.contains("side-closed");
    if (hasClass) {
      this.renderer.removeClass(this.document.body, "side-closed");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    } else {
      this.renderer.addClass(this.document.body, "side-closed");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }


  logout() {
    // this.callFullscreen();
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
    this.authService
      .logintracker({
        loginTrackId: localStorage.getItem("loginTrackId"),
        btn_name: "LOGOUT",
      })
      .subscribe((response) => {});
    this.subs.sink = this.authService.logout().subscribe((res) => {
      if (!res.success) {
        localStorage.clear();
        sessionStorage.removeItem('cashTransferNav');
        this.tabSyncService.notifyLogout();
        this.router.navigate(["/authentication/signin"]);
      }
    });
  }
  getLegalEntityName(legalEntityId: number): string {
    const entity = this.roleData.find((d) => d.legalEntityId === legalEntityId);
    return entity ? entity.legalEntityName : "";
  }
  getBusinessArea(id, legalEntityName: string) {
    console.log(legalEntityName);
    this.nav_dropdown_check.legalEntityId = id;
    localStorage.setItem("legalEntityId", id.toString());
    localStorage.setItem("legalEntityName", legalEntityName);
    localStorage.setItem("locationId", "0");
    localStorage.setItem("businessSegmentsId", "0");
    localStorage.setItem("businessAreaId", "0");
    localStorage.setItem("locationName", "");
    localStorage.setItem("businessSegmentsName", "");
    localStorage.setItem("businessAreaName", "");
    this.businessArea = parseInt(localStorage.getItem("locationId"));
    this.businessVertical = parseInt(
      localStorage.getItem("businessSegmentsId"),
    );
    this.BusinessUnit1 = parseInt(localStorage.getItem("businessAreaId"));
    this.ViewBusinessArea = [];
    this.authService.setRole(this.roleId);

    this.authService.notifyDropdownChange();
    this.authService.moduleList();
    this.configservice
      .getalldependency({
        btn_name: "GETACTUALBUSINESSAREA",
        legalEntityId: id,
        userId: localStorage.getItem("userId"),
        roleID: localStorage.getItem("roleId"),
      })
      .subscribe((res) => {
        console.log(res);
        // localStorage.setItem("actuallBusinessAreaId", res[0].actuallBusinessAreaId);
        // console.log("actuallBusinessAreaId", res[0].actuallBusinessAreaId)
        // console.log(res[0].actuallBusinessAreaId)

        this.ViewBusinessArea = res;
        this.ViewBusinessVertical = [];
        this.BusinessUnit = [];
        this.businessArea = parseInt(localStorage.getItem("locationId"));

        this.selectDropdowns();
        if (this.businessArea > 0) {
          this.getBusinessVertical(this.businessArea);
        }
      });
  }
  getBusinessVertical(id) {
    this.nav_dropdown_check.locationId = id;
    this.BusinessUnit = [];
    localStorage.setItem("locationId", id);
    localStorage.setItem("businessSegmentsId", "0");
    localStorage.setItem("businessAreaId", "0");
    localStorage.setItem("businessSegmentsName", "");
    localStorage.setItem("businessAreaName", "");
    this.businessVertical = parseInt(
      localStorage.getItem("businessSegmentsId"),
    );
    this.BusinessUnit1 = parseInt(localStorage.getItem("businessAreaId"));
    this.authService.setRole(this.roleId);

    // localStorage.setItem('businessSegmentsId',localStorage.getItem('businessSegmentsId') !== null ? localStorage.getItem('businessSegmentsId') : '0');
    // localStorage.setItem('businessAreaId',localStorage.getItem('businessAreaId') !== null ? localStorage.getItem('businessAreaId') : '0');
    this.authService.notifyDropdownChange();
    this.configservice
      .getalldependency({
        btn_name: "GETACTUALBUSINESSVERTICAL_BYAREA",
        legalEntityId: this.legalEntity,
        locationId: localStorage.getItem("locationId"),
        userId: localStorage.getItem("userId"),
        roleID: localStorage.getItem("roleId"),
      })
      .subscribe((res) => {
        this.ViewBusinessVertical = res;
        this.BusinessUnit = [];
        this.businessVertical = parseInt(
          localStorage.getItem("businessSegmentsId"),
        );
        this.selectDropdowns();
        if (this.businessVertical > 0) {
          this.getBusinessUnit(this.businessVertical);
        }
      });
  }
  getBusinessUnit(id) {
    this.nav_dropdown_check.businessSegmentsId = id;
    localStorage.setItem("businessSegmentsId", id);
    localStorage.setItem("businessAreaId", "0");
    localStorage.setItem("businessAreaName", "");
    this.BusinessUnit1 = parseInt(localStorage.getItem("businessAreaId"));
    this.selectDropdowns();
    this.authService.setRole(this.roleId);

    // localStorage.setItem('businessAreaId',localStorage.getItem('businessAreaId') !== null ? localStorage.getItem('businessAreaId') : '0');
    this.authService.notifyDropdownChange();

    this.configservice
      .getalldependency({
        legalEntityId: this.legalEntity,
        locationId: localStorage.getItem("locationId"),
        businessSegmentsId: id,
        btn_name: "GETACTUALBUSINESSUNIT",
        userId: localStorage.getItem("userId"),
        roleID: localStorage.getItem("roleId"),
        businessAreaId: localStorage.getItem("businessAreaId"),
      })
      .subscribe((res) => {
        this.BusinessUnit = res;
        this.BusinessUnit1 = parseInt(localStorage.getItem("businessAreaId"));
      });
  }

  onRoleChange(event: any): void {
    this.roleId = event.value.toString();
    localStorage.setItem("roleId", this.roleId);
    console.log(localStorage.getItem("legalEntityId"));
    this.fetchRoleData();
    console.log("Selected role:", event.value);
    this.authService.setRole(event.value);
    const foundRole = this.viewRole?.find(
      (role) => role.roleId === event.value,
    );
    localStorage.setItem("roleName", foundRole ? foundRole.roleName : null);
    localStorage.setItem("roleCode", foundRole ? foundRole.roleCode : null);
  }
  fetchRoleData(): void {
    const userId = localStorage.getItem("userId");
    const label = localStorage.getItem("roleId");
    const legalEntityId = localStorage.getItem("legalEntityId");

    this.configservice.getMyRoleData(userId, label, legalEntityId).subscribe(
      (data) => {
        this.roleData = data;
        console.log("Role Data:", this.roleData);
        if (this.roleData && this.roleData.length > 0) {
          this.legalEntity = this.roleData[0];
          console.log(
            this.legalEntity
              ? this.legalEntity.legalEntityName
              : "legalEntity is undefined",
          );
          // localStorage.setItem('legalEntityNamenew', this.legalEntity.legalEntityName);
          console.log(
            "Stored legalEntityName:",
            this.legalEntity.legalEntityName,
          );
          let storedName = localStorage.getItem("legalEntityName");
          // console.log(localStorage.getItem('legalEntityNamenew'));
          localStorage.setItem(
            "legalEntityName",
            this.legalEntity.legalEntityName,
          );
          console.log(localStorage.getItem("legalEntityName"));
        }
      },
      (error) => {
        console.error("Error fetching role data:", error);
      },
    );
    this.loadDependencies();
    this.legalEntity = parseInt(localStorage.getItem("legalEntityId"));
  }
}
